import { Box, Checkbox, Text, Textarea } from "@chakra-ui/react";
import { Col, Row } from "antd";
import SelectGrupoUnidade from "components/Input/SelectGrupoUnidade";
import { TipoEstruturaMoradiaEnum } from "core/resources/enums/tenant";
import { Control } from "react-hook-form";
import Field from "ui/components/Input/Field";
import InputMoney from "ui/components/Input/InputMoney";
import SelectBlocoQuadra from "ui/components/Input/SelectBlocoQuadra";

interface FormUnidadeProps {
  control: Control<any>;
  tenantId: string;
  tipoEstruturaMoradia: TipoEstruturaMoradiaEnum;
  isEdit?: boolean;
}

function FormUnidade({
  control,
  tenantId,
  tipoEstruturaMoradia,
  isEdit,
}: FormUnidadeProps) {
  return (
    <>
      <Row gutter={16}>
        <Box as={Col} md={6} mb={6}>
          <Field
            label="Número da unidade"
            control={control}
            name="numero"
            rules={{
              required: true,
            }}
          />
        </Box>

        {tipoEstruturaMoradia === TipoEstruturaMoradiaEnum.Bloco ||
          tipoEstruturaMoradia === TipoEstruturaMoradiaEnum.Quadra ? (
          <Box as={Col} md={6} mb={6}>
            <Field
              label={
                tipoEstruturaMoradia === TipoEstruturaMoradiaEnum.Bloco
                  ? "Bloco"
                  : "Quadra"
              }
              control={control}
              name="blocoQuadraId"
              rules={{
                required: true,
              }}
              render={({ field, isInvalid }) => (
                <SelectBlocoQuadra
                  isInvalid={isInvalid}
                  tenantId={tenantId}
                  placeholder={
                    tipoEstruturaMoradia === TipoEstruturaMoradiaEnum.Bloco
                      ? "Bloco"
                      : "Quadra"
                  }
                  {...field}
                />
              )}
            />
          </Box>
        ) : null}

        <Box as={Col} md={6} mb={3}>
          <Field
            label="Fração"
            control={control}
            name="fracao"
            render={({ field }) => (
              <InputMoney decimalScale={8} decimalsLimit={8} {...field} />
            )}
          />
        </Box>

        <Box as={Col} md={6} mb={3}>
          <Field
            label="Peso"
            control={control}
            name="peso"
            inputProps={{
              type: "number",
            }}
          />
        </Box>
      </Row>

      <Row gutter={16}>
        <Box as={Col} md={6} mb={3}>
          <Field
            label="Área Privativa Total (m2)"
            control={control}
            name="area"
            render={({ field }) => (
              <InputMoney decimalScale={3} decimalsLimit={3} {...field} />
            )}
          />
        </Box>

        <Box as={Col} md={6} mb={3}>
          <Field
            label="Área construída (m2)"
            control={control}
            name="areaConstruida"
            render={({ field }) => (
              <InputMoney decimalScale={3} decimalsLimit={3} {...field} />
            )}
          />
        </Box>

        {isEdit ? (
          <Box as={Col} md={12} mb={3}>
            <Field
              label="Grupos de unidade"
              control={control}
              name="gruposUnidadesIds"
              render={({ field, isInvalid }) => (
                <SelectGrupoUnidade
                  mode="multiple"
                  isInvalid={isInvalid}
                  placeholder="Nenhum grupo"
                  {...field}
                />
              )}
            />
          </Box>
        ) : null}

        {/* <Box as={Col} md={8} mb={3}>
          <Field
            label="Desconto para Síndico (%)"
            control={control}
            name="descontoSindico"
            render={({ field }) => <InputMoney {...field} />}
          />
        </Box> */}
      </Row>

      <Row gutter={16}>
        <Box as={Col} md={6} mb={3}>
          <Field
            control={control}
            name="ajuizada"
            render={({ field }) => (
              <Checkbox
                isChecked={field.value}
                onChange={() => field.onChange(!field.value)}
              >
                <Text>Ajuizada?</Text>
              </Checkbox>
            )}
          />
        </Box>
      </Row>

      <Row gutter={16}>
        <Box as={Col} xs={24}>
          <Field
            label="Observação"
            name="observacao"
            inputProps={{ type: "text" }}
            control={control}
            render={({ field, isInvalid }) => (
              <Textarea
                isInvalid={isInvalid}
                className="chakra-input"
                rows={4}
                placeholder="Digite..."
                {...field}
              />
            )}
          />
        </Box>
      </Row>
    </>
  );
}

export default FormUnidade;
